const PlansData = {
  employerPlans: {
    title: "Employer Hiring Plans",

    plans: [
      /* ───────── PLAN 1 ───────── */
      {
        name: "VALUE",
        price: "15,000",
        // example: each plan can have its own set of top-up options
        topups: [
          { id: "jobs2", label: "Extra 2 Unique job posting – ₹4,000", price: 4000 },
          { id: "cv10", label: "Extra 10 Shortlisted CVs – ₹4,000", price: 4000 },
          { id: "interviews5", label: "Extra 5 Online Interviews – ₹10,000", price: 10000 },
        ],
        features: [
          "Unique Job Posting – 2 per year",
          "CVs – 10 per year",
          "Online Interviews – 5 per year",
        ]
      },

      /* ───────── PLAN 2 ───────── */
      {
        name: "MAX",
        price: "30,000",
        highlight: true,
        topups: [
                { id: "jobs4", label: "Extra 4 Unique job posting – ₹8,000", price: 8000 },
          { id: "cv25", label: "Extra 25 CVs – ₹75,00", price: 7500 },
        { id: "interviews8", label: "Extra 8 Online Interviews – ₹10,000", price: 16000 },
        ],
        features: [
          "Unique Job Posting – 4 per year",
          "CVs – 25 per year",
          "Online Interviews – 8 per year",
        ]
      },

      /* ───────── PLAN 3 ───────── */
      {
        name: "SUPER MAXX",
        price: "50,000",
        topups: [
           { id: "jobs8", label: "Extra 8 Unique job posting – ₹12,000", price: 12000 },
          { id: "cv50", label: "Extra 50 CVs – ₹12,500", price: 12500 },
        { id: "interviews15", label: "Extra 15 Online Interviews – ₹30,000", price: 30000 },
              ],
        features: [
          "Unique Job Posting – 8 per year",
          "CVs – 50 per year",
          "Online Interviews – 15 per year",

        ]
      }
    ]
  }
};

export default PlansData;